<template>
  <div class="text-right mb-1">
    <v-menu :close-on-content-click="false" bottom offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-badge :value="messages.length" :content="messages.length" color="black" overlap>
          <v-btn v-bind="attrs" v-on="on" text small :aria-label="title + ' comments'">
            <v-icon color="secondary">chat</v-icon>
          </v-btn>
        </v-badge>
      </template>
      <v-card width="300" style="text-align: left;">
        <chatbox :messages="messages" :title="title" @sendMessage="$emit('sendMessage', $event)" />
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import chatbox from './chatbox'

export default {
  name: 'EditorComments',
  components: { chatbox },
  props: {
    messages: { type: Array, required: true },
    title: { type: String, required: true }
  }
}
</script>



// WEBPACK FOOTER //
// EditorComments.vue?b68c5220